import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Typography,
  Icon,
  Input,
  Dropdown,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
// import OtpInputFields from "../OtpInputFields";
import styled from "styled-components";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { TURNSTILE_SITE_KEY } from "../../constants/AppConstant";
import { MOBILE_NO_ERROR } from "../../constants/AppConstant";
import OtpInputFields from "../../components/OtpInputFields";
const BorderDiv = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const StyledForm = styled.form`
  height: fit-content;
`;

const StyledDropdown = styled(Dropdown).attrs()`
  width: 154px !important;
`;

const MobileOtp = (props) => {
  const [seconds, setSeconds] = useState(60);
  const [showInvalidError, toggleError] = useState(false);
  let intervalRef = useRef();

  const decreaseNum = () => setSeconds((prev) => prev - 1);

  useEffect(() => {
    intervalRef.current = setInterval(decreaseNum, 1000);
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    props.otpValue?.length === 6 && handleValidateOtp();
  }, [props.otpValue]);

  const handleResendClick = (token = "") => {
    setSeconds(60);
    intervalRef.current = setInterval(decreaseNum, 1000);
    props.resendOtp(token);
  };

  if (seconds === 0) {
    clearInterval(intervalRef.current);
  }

  const handleOtpInput = (otp) => {
    toggleError(false);
    props.updateOtp(otp);
  };

  const handleValidateOtp = () => {
    if (props.otpValue && props.otpValue.length !== 6) {
      toggleError(true);
      return;
    }
    props.validateOtp();
  };

  return (
    <>
      <div>
        {props.step === 1 && (
          <StyledForm onSubmit={props.handleSendOtp}>
            <div className="d-flex flex-column w-100">
              <Typography.H3 color="dark" shade="300">
                Enter your Mobile Number
              </Typography.H3>
              <Typography
                component="div"
                color="dark"
                shade="c200"
                className="mt-4"
              >
                Enter your mobile number you wil use to authenticate your
                account and enhance the security.
              </Typography>
              <div className="d-flex flex-row mt-32 ">
                <StyledDropdown
                  id="recharge-phone-code-dropdown"
                  placeholder="Phone Code"
                  options={props.phone_codes_ui}
                  value={props.isd_code_object}
                  onChange={(event) => {
                    props.handleISDchange(event);
                  }}
                  noOptionsMessage={() => {
                    return "No Code";
                  }}
                  isDisabled={props.isMobieDisabled}
                  isCreatable={true}
                />

                <Input
                  id="recharge-phone-number-input-box"
                  placeholder="Enter phone number"
                  onChange={(e) => props.handleMobileChange(e)}
                  value={props.phnNumber}
                  error={props.phnNumError}
                  helperText={props.phnNumError ? MOBILE_NO_ERROR : null}
                  disabled={props.isMobieDisabled}
                  suffix={
                    props.isMobieDisabled ? (
                      <Tooltip
                        offset={[0, 10]}
                        tooltip={"Phone number is verified."}
                      >
                        <Icon
                          color="dark"
                          iconName="PlumCheckbox"
                          shade="c100"
                          size="24"
                        />
                      </Tooltip>
                    ) : null
                  }
                  style={{ width: "285px" }}
                />
              </div>
            </div>

            <div className="d-flex flex-row mt-36">
              <div className="ml-auto">
                <Button
                  variant="plain"
                  onClick={() => props.setMobileAuthenticationStep(false)}
                >
                  Back
                </Button>
                {props.renderTurnstileCaptcha ? (
                  <Turnstile
                    siteKey={TURNSTILE_SITE_KEY}
                    onSuccess={(token) =>
                      props.handleGenerateRechargeOtp(token)
                    }
                    options={{ theme: "light" }}
                    style={{ width: "100%" }}
                  />
                ) : (
                  <Button
                    id="mfa-send-otp-btn"
                    onClick={props.handleSendOtp}
                    disabled={props.enableMobileMFALoading || props.disableBtn}
                    loading={props.enableMobileMFALoading}
                    type="submit"
                    className="ml-12"
                  >
                    <span id="mfa-send-otp">Send OTP</span>
                  </Button>
                )}
              </div>
            </div>
          </StyledForm>
        )}

        {props.step === 2 && (
          <div className="d-flex flex-column">
            <Typography.H2 color="dark" shade="300">
              Verify via OTP
            </Typography.H2>

            <div className="d-flex flex-row mt-32">
              <div className="d-flex flex-column">
                <Typography.LabelText
                  color="dark"
                  shade="c200"
                  className="ml-0 pl-0"
                >
                  Mobile number
                </Typography.LabelText>
                <Typography color="dark" shade="c300" className="mb-0">
                  {props.isd_code_object.phonecode || "+91"}
                  {"-"}
                  {props.phnNumber || ""}
                </Typography>
              </div>
              <Button
                variant="plain"
                color="primary"
                onClick={() => props.setStep(1)}
                className="ml-auto"
              >
                Change
              </Button>
            </div>
            <BorderDiv className="my-32"></BorderDiv>
            <div
              style={{
                maxWidth: "420px",
              }}
            >
              <Typography.HelperText color="dark" shade="c200" className="mb-0">
                We've sent a One Time Password (OTP) to your phone number. Enter
                it to complete verification.
              </Typography.HelperText>
              <OtpInputFields
                onComplete={(data) => handleOtpInput(data)}
                otp={props.otpValue}
                otpAutoFocusTrigger={props.otpAutoFocusTrigger}
                triggerFocus={() =>
                  props.triggerFocus(!props.otpAutoFocusTrigger)
                }
                className="my-16"
                error={props.invalidOtpMsg || showInvalidError}
              />
              {props.invalidOtpMsg || showInvalidError ? (
                <Typography.HelperText
                  color="red"
                  shade="c300"
                  className="d-flex"
                >
                  Invalid OTP. Please check your code and try again.
                </Typography.HelperText>
              ) : null}
              {props.showResendMsg ? (
                <Typography color="green" shade="c300">
                  <Icon
                    color="green"
                    iconName="Right"
                    onClick={() => {}}
                    shade="c300"
                    size="18"
                  />{" "}
                  A new OTP has been sent to your mobile number
                </Typography>
              ) : null}
            </div>
            <div className="d-flex flex-row mt-32 align-items-center">
              <div>
                {seconds > 0 ? (
                  <Typography.ButtonText
                    color="dark"
                    shade="c200"
                    className="m-0"
                  >
                    Resend OTP in {seconds} second(s)
                  </Typography.ButtonText>
                ) : (
                  <>
                    <Button
                      variant="plain"
                      color="primary"
                      className="pl-0"
                      onClick={() => {
                        if (props.showCts) {
                          props.toggleRenderTurnstile(true);
                        } else {
                          handleResendClick("");
                        }
                      }}
                    >
                      Resend OTP
                    </Button>
                  </>
                )}
              </div>
              <div className="ml-auto">
                <Button
                  disabled={
                    props.otpValue.length !== 6 ||
                    props.showOtpLoading ||
                    props.showOtpLoading ||
                    props.enableMobileMFALoading
                  }
                  onClick={() => handleValidateOtp()}
                  loading={props.enableMobileMFALoading || props.showOtpLoading}
                  className="ml-16"
                >
                  Verify
                </Button>
              </div>
            </div>
            {props.renderResendTurnstileCaptcha ? (
              <Turnstile
                className="h-100"
                siteKey={TURNSTILE_SITE_KEY}
                onSuccess={(token) => handleResendClick(token)}
                options={{ theme: "light" }}
                style={{ width: "100%" }}
              />
            ) : null}
          </div>
        )}
      </div>
    </>
  );
};

export default MobileOtp;
